export default __webpack_public_path__ + "img/treatment-plan-run.eb7dbd00.png";